import { setAuthToken } from "@/libs/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isLoggedIn: false,
  accessToken: "",
  roles: [],
};

export const userSlice = createSlice({
  name: "admin_user",
  initialState: initialState,
  reducers: {
    /**
     * Adds user data to the Redux store after successful login.
     * @param {Object} state - Current Redux state
     * @param {Object} action - Redux action with payload containing userData and accessToken
     */
    addUser: (state, action) => {
      state.user = action.payload.userData;
      state.isLoggedIn = true;
      state.accessToken = action.payload.accessToken;
      state.roles = action.payload.userData?.roles || [];
      setAuthToken(action.payload.accessToken);
    },
    /**
     * Clears user data from the Redux store (logout).
     * @param {Object} state - Current Redux state
     */
    clearUser: (state) => {
      state.user = null;
      state.isLoggedIn = false;
      state.accessToken = "";
      state.roles = [];
    },
    /**
     * Updates user data in the Redux store after profile update.
     * @param {Object} state - Current Redux state
     * @param {Object} action - Redux action with payload containing userData and optional accessToken
     */
    updateUserData: (state, action) => {
      state.user = action.payload.userData;
      state.roles = action.payload.userData?.roles || state.roles;
      if (action.payload.accessToken) {
        state.accessToken = action.payload.accessToken;
        setAuthToken(action.payload.accessToken);
      }
    },
    /**
     * Resets the user state to initial values (logout).
     */
    logoutSuccess: () => {
      setAuthToken(null);
      return initialState;
    },
  },
});

export const {
  addUser,
  clearUser,
  logoutSuccess,
  updateUserData,
} = userSlice.actions;

// Selector to get the logged-in user data
export const loggedUser = (state) => state.user;

export const userRoles = (state) => state.user?.user?.roles || [];

export default userSlice.reducer;
